import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { Fab } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import IntlMessages from 'util/IntlMessages';
import { ToastContainer, toast } from 'react-toastify';
import {
  hideMessage,
  userSignInSuccess
} from 'actions/Auth';
import { useAccess } from '../contexts/AccessContext';
import { _auth, _getEmp, _getUser } from '../services/login.service';
import FormDialog from '../app/routes/ComponentesJumbo/components/routes/dialogs/formAlerts/FormDialog';
import CheckBoxListControl from '../app/routes/ComponentesJumbo/components/routes/list/checkBoxListControl/CheckBoxListControl';
import { makeStyles } from '@material-ui/core/styles';
import { logoImg, primary } from 'configs/CustomColors';
import WhatsappIcon from '@material-ui/icons/WhatsApp';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
//import { width } from '@amcharts/amcharts4/.internal/core/utils/Utils';
import ModalAtualizarCertificado from '../components/ModalCertificado';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  body: {
    fontFamily: "'Roboto', Arial, sans-serif",
    background: 'linear-gradient(to right, #6a11cb, #2575fc)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    margin: 0,
  },
  loginContainer: { //o que envolve o formulario de login
    background: '#fff',
    padding: '2rem',
    borderRadius: '10px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    width: '100%',
    maxWidth: '400px',
  },
  logo: {
    width: '120px',
    marginBottom: '1rem',
  },
  header: {
    fontSize: '1.5rem',
    marginBottom: '1rem',
    color: '#333',
  },
  input: {
    width: '100%',
    padding: '0.8rem',
    margin: '0.5rem 0',
    border: '1px solid #ddd',
    borderRadius: '5px',
    fontSize: '1rem',
    '&:focus': {
      borderColor: '#6a11cb',
      outline: 'none',
    },
  },
  button: {
    background: '#6a11cb',
    color: '#fff',
    border: 'none',
    padding: '0.8rem',
    width: '100%',
    borderRadius: '5px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background 0.3s ease',
    '&:hover': {
      background: '#2575fc',
    },
  },
  link: {
    display: 'block',
    marginTop: '1rem',
    fontSize: '0.9rem',
    color: '#6a11cb',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  passwordToggle: {
    position: 'relative',
  },
  toggleIcon: {
    position: 'absolute',
    right: '10px',
    top: '50%',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
  },
}));

const success = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000
  });
}

const error = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_RIGHT,
    autoClose: 3000
  });
}

function openWhatsapp() {
  window.open("https://api.whatsapp.com/send?phone=5562982609109", '_blank').focus();
}

const SelectEmpresa = ({ empresas, thispatch }) => {
  return (
    <CheckBoxListControl data={empresas} locale={"empresas"} dispatch={thispatch} />
  )
}

const SignIn = (props) => {
  const classes = useStyles();
  const [empresas, setEmpresas] = useState([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [form, setForm] = useState(false);
  const [token, setToken] = useState();
  const [user, setUser] = useState();
  const dispatch = useDispatch();
  const [backdrop, setBackdrop] = useState(false);
  const [modalEmpresaVencida, setModalEmpresaVencida] = useState(false);
  const [dadosVencimentoCertificado, setDadosVencimentoCertificado] = useState({});
  const [empresa, setEmpresa] = useState(null);
  const { showMessage, authUser } = useSelector(({ auth }) => auth);
  const [tipoTypeSenha, setTipoTypeSenha] = useState('password');
  const { updateAccess, getCertificateData } = useAccess();

  useEffect(() => {
    if (props.history.location.state) {
      success(props.history.location.state.msg);
      props.history.push({ pathName: '/', state: undefined });
    }
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
    if (authUser !== null && sessionStorage.getItem("@Emissor/cnpj")) {
      props.history.push('/');
    }

  }, [showMessage, authUser, props.history, dispatch]);

  const closeForm = () => setForm(false);

  const thispatch = async (empresa, continuarLogin = false) => {
    if (!empresa) {
      setBackdrop(false);
      return;
    }
    setEmpresa(empresa);

    // se for no canal do parceiro
    if (empresa.parceiro) {
      sessionStorage.setItem("@Emissor/cnpj", 1);

      // TODO: Corrigir typo no backend para "mensalidadeVencida"
      updateAccess({ acesso: { mesalidadeVencida: false } });
      dispatch(userSignInSuccess({
        email,
        password,
        token: token,
        name: sessionStorage.getItem("@Emissor/UserName"),
        mail: sessionStorage.getItem("@Emissor/UserMail")
      }));
      setBackdrop(false);
    } else {
      const dadosVencimento = getCertificateData(empresa);

      if (!continuarLogin && dadosVencimento.modalAtualizarCertificado) {
        setBackdrop(false);
        setDadosVencimentoCertificado(dadosVencimento);
        setModalEmpresaVencida(true);
        return;
      }

      setBackdrop(true);
      sessionStorage.setItem("@Emissor/idEmpresa", empresa?.dadosLocais?.id);
      sessionStorage.setItem("@Emissor/cnpj", empresa?.dadosLocais?.nu_cnpj);
      sessionStorage.setItem("@Emissor/nomeEmpresa", empresa?.dadosLocais?.tx_razao_social);
      sessionStorage.setItem("@Emissor/crt", empresa?.crt);
      sessionStorage.setItem("@Emissor/logo", empresa?.logo_nfce);
      sessionStorage.setItem("@Emissor/dataCertificado", empresa?.dt_venc_certificado);
      //sessionStorage.setItem("@Emissor/dataVencimento", empresa.ambiente === "2" ? "2040-01-01" : dataAcesso); //FIXME: Mudei aqui para liberar
      sessionStorage.setItem("@Emissor/dataVencimento", '2025-12-25'); ///FIXME:Mudei aqui para liberar
      //sessionStorage.setItem("@Emissor/ambiente", empresa.ambiente); //FIXME:Mudei aqui para liberar

      // Atualiza o Context com base nos dados da API, não do sessionStorage
      console.log('Verifcando acesso - mensalidade vencida? ', JSON.stringify(empresa?.acesso));
      //updateAccess(empresa?.acesso?.mensalidadeVencida ? false : true);

      //if (empresa.ambiente === "2") { dataAcesso = "2040-01-02"; dispatch(notAllowed(false)); } //FIXME: Mudei aqui para liberar
      dispatch(userSignInSuccess({ email, password, token: token, name: user.name, mail: user.mail }));
      updateAccess(empresa);
      setBackdrop(false);
    }
  }


  //clicar no botão de login
  const makeAuth = async () => {
    setBackdrop(true); //exibir o backdrop de loading
    const responseAuth = await _auth({ email, password })

    console.log(responseAuth.data.msg);
    sessionStorage.setItem("@Emissor/Token", responseAuth.data.msg);

    let tokenf = responseAuth.data.msg;
    setToken(responseAuth.data.msg);

    try {
      console.log('tokenf', tokenf);

      const responseUser = await _getUser({ headers: { "Authorization": "Bearer " + tokenf } })

      console.log('responseUser', responseUser);
      // console.log(responseUser.data);

      sessionStorage.setItem("@Emissor/UserName", responseUser.data.usuario.name);
      sessionStorage.setItem("@Emissor/uid", responseUser.data.usuario.id);
      sessionStorage.setItem("@Emissor/UserMail", responseUser.data.usuario.email);
      sessionStorage.setItem("@Emissor/UserImg", responseUser.data.usuario.imagem);
      sessionStorage.setItem("@Emissor/Type", responseUser.data.usuario.tipo);

      setUser(responseUser.data.usuario);
      if (responseUser.data.usuario.tipo !== "PC") {
        //await _getEmp('', { headers: { "Authorization": "Bearer " + tokenf } }).then(async response => {
        if (responseUser.data.empresas.length === 0) {
          setBackdrop(false);
          error("Nenhuma empresa encontrada para este usuário.");
          sessionStorage.removeItem("@Emissor/Token");
        } else {
          setEmpresas(responseUser.data.empresas);
          setForm(true);
          setBackdrop(false);
        }

        //.catch(erro => { setBackdrop(false); error("Ocorreu um erro ao realizar login. Confira os dados informados") })
      } else {
        setBackdrop(false);
        thispatch({ parceiro: true });
      }

    } catch (error) {
      setBackdrop(false);
      console.log(error);
      console.error("Ocorreu um erro ao realizar login. Confira os dados informados");
    }
  }




  return (
    <>
      <Backdrop style={{ zIndex: '99999' }} className={classes.backdrop} open={backdrop}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className={`${classes.body}`}>
        <ToastContainer />
        <div className={`${classes.loginContainer} animated slideInUpTiny animation-duration-3`}>
          {/* centralize  a logo criando uma div pai para a div abaixo */}

          <div className="">
            <Link className="logo-lg" to="/app/vendas/area" title="Logo">
              {/* <img src={require('../assets/images/icon.png')} className={classes.logo} alt="Logo" title="Logo" /> */}
              <img src={require('../assets/images/logo.png')} className={classes.logo} alt="Logo" title="Logo" />
            </Link>
          </div>

          {/* <div className="app-logo-content d-flex align-items-center justify-content-center mb-4">
            <Link style={{backgroundColor:"red"}} className="logo-lg" to="/app/vendas/area" title="Logo">
              {(() => {
                if (sessionStorage.getItem("@Emissor/logoHorizontal") !== 'undefined') {
                  return <img src={`data:image/png;base64,${sessionStorage.getItem("@Emissor/logoHorizontal")}`}
                    className={classes.logo} alt="Logo" title="Logo" />
                } else {
                  return <img src={require('../assets/images/icon.png')} className={classes.logo} alt="Logo" title="Logo" />
                }
              })()}
            </Link>
          </div> */}

          <div className={classes.header}>
            <h1>Emissor de Nota Fiscal</h1>
          </div>

          {/* <div className="app-login-content"> */}
          <div className="app-login-form">
            <form>
              <fieldset>
                <TextField
                  label={<IntlMessages id="appModule.email" />}
                  fullWidth
                  onChange={(event) => {
                    const regex = /^[a-zA-Z0-9@._-]+$/;
                    if (!regex.test(event.target.value)) {
                      event.target.value = event.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
                    }
                    setEmail(event.target.value)
                  }}
                  defaultValue={email}
                  margin="normal"
                  //className={classes.input}
                  variant="outlined"
                />
                <div className={classes.passwordToggle}>
                  <TextField
                    onKeyDown={(event => {
                      if (event.key === 'Enter') {
                        makeAuth();
                      }
                    })}
                    type={tipoTypeSenha}
                    label={<IntlMessages id="appModule.password" />}
                    fullWidth
                    onChange={(event) => setPassword(event.target.value)}
                    defaultValue={password}
                    margin="normal"
                    //className={classes.input}
                    variant="outlined"
                  />
                  <i className={classes.toggleIcon}
                    onClick={() => { tipoTypeSenha === 'password' ? setTipoTypeSenha('text') : setTipoTypeSenha('password') }}
                  >

                    {tipoTypeSenha === 'password' ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </i>
                </div>

                <div className="mb-3 d-flex flex-column align-items-center">
                  <Button onClick={() => {
                    makeAuth();
                  }} variant="contained" className={classes.button}>
                    <IntlMessages id="appModule.signIn" />
                  </Button>

                  <div className=" ">
                    <Link to="/recover-password" className={classes.link}>
                      <IntlMessages id="signIn.forgot" />
                    </Link>
                  </div>

                  <div className="mt-3">
                    <Link to="/signup" className={classes.link} style={{ marginTop: '0rem' }}>
                      <IntlMessages id="signIn.signUp" />
                    </Link>
                  </div>

                </div>

              </fieldset>
            </form>
          </div>
          {/* </div> */}

        </div>
        {form &&
          <FormDialog maxWidth={"lg"} title="Selecione uma empresa para trabalhar"
            close={closeForm} children={<SelectEmpresa setForm={closeForm} empresas={empresas} thispatch={thispatch} />}
          />
        }
        {
          modalEmpresaVencida &&
          <ModalAtualizarCertificado open={modalEmpresaVencida} dados={dadosVencimentoCertificado} close={() => {
            setModalEmpresaVencida(false);
            thispatch(empresa, true);
          }} />
        }
      </div>

      <Fab style={{
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
        backgroundColor: "#128c7e",
        color: 'white'
      }} variant="extended" aria-label="add"
        onClick={openWhatsapp}>
        <WhatsappIcon />
        Suporte
      </Fab>
    </>
  );
};


export default SignIn;
